module.exports = __webpack_public_path__ + "media/images/bi-x-0b61bf01.svg";